/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SubscribeResponseType } from './subscribeResponseType';

export interface SubscribeResponse {
  type: SubscribeResponseType;
  client_secret: string;
  subscription_id: string;
}
